export let super_config = [
    {
        elements: [
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'input',
				placeholder: 'Название темы',
				label: 'Название темы'
			},
			{
				elementGetParamMap: 'test_input',
				element_model: '',
				elementType: 'textarea',
				placeholder: 'Описание темы',
				label: 'Описание темы'
			},
			{
				elementGetParamMap: 'test_ajax_list',
				elementType: 'ajax-list',
				element_model: {},
				label: 'Отвественный',
				placeholder: "Выбрать отвественного",
				objApiMethod: { 'obj': 'staff', 'flt': { 'fio': '' } },
				strApiMethodKey: "fio",
			},
			{
				elementGetParamMap: 'test_ajax_list_tags',
				elementType: 'ajax-list-tags',
				element_model: [],
				label: 'Пригласить сотрудников',
				placeholder: "Пригласить сотрудников",
				objApiMethod: { 'obj': 'staff', 'flt': { 'fio': '' } },
				strApiMethodKey: "fio",
			},
			{
				elementGetParamMap: 'test_input-date',
				elementType: 'input-date',
				element_model: '',
				label: 'Дата события',
				placeholder: 'Дата события',
			},
			{
				elementGetParamMap: 'sts|ste',
				elementType: 'input-time-range',
				element_model: {startDt:'',endDt:''},
				label: 'Длительность  события',
				range_separator: '-',
				start_placeholder: 'Время с',
				end_placeholder: 'Время по',
			},
			{
				elementGetParamMap: 'test_radio-group',
				element_model: '0',
				elementType: 'radio-group',
				label: 'Место проведения',
				options: [{name: '0', label: 'Вне офиса',},{name: '1', label: 'В офисе',}]
			},

			//далее идет группа новых компонентов -- Место проведения

        ]
    }
]